import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Avatar.scss'

import noAvatarFemaleImage from './images/female.svg'
import noAvatarMaleImage from './images/male.svg'


const Avatar = ({ className, gender, src, circle, alt }) => {
  const imgSrc = src || (gender === 'female' ? noAvatarFemaleImage : noAvatarMaleImage)

  const avatarClassName = cx(s.avatar, className, {
    [s.noSrc]: !src,
    [s.circle]: circle,
  })

  return (
    <img className={avatarClassName} src={imgSrc} alt={typeof alt === 'undefined' ? 'avatar' : alt} />
  )
}

Avatar.propTypes = {
  className: PropTypes.string,
  gender: PropTypes.string,
  circle: PropTypes.bool,
  src: PropTypes.string,
}

Avatar.defaultProps = {
  gender: 'female',
}


export default Avatar
